export default __webpack_public_path__ + "static/media/notaminotaur.6ed1ba0e.png";